import api from "@/service";
const {
    apiUserRenewByCurrency,
    apiUserRenewByRenewCurrency,
    apiUserPttSetFunctions,
    apiuserPttGetFunctions,
    apiuserPttGetFuncGroupList,
    apiuserPttGetUserInfo,
    apiBatchRenewByCurrency,
    apiUserPttSetFunctionsV2,
} = api;
export default {
    namespace: "user",
    state: {
    },
    subscriptions: {
        setup({ dispatch, history }) { },
    },
    effects: {
        //用户虚拟币续费
        *renewByCurrency({ payload }, { put, call }) {
            let datas = yield call(apiUserRenewByCurrency, payload)
            return datas
        },
        //用户续费币续费
        *renewByRenewCurrency({ payload }, { put, call }) {
            let datas = yield call(apiUserRenewByRenewCurrency, payload)
            return datas
        },
        // 用户批量续费
        *batchRenew({ payload }, { put, call }) {
            let datas = yield call(apiBatchRenewByCurrency, payload)
            return datas
        },
        //用户功能设置
        *setUserPttFunctions({ payload }, { put, call }) {
            let datas = yield call(apiUserPttSetFunctions, payload)
            return datas
        },
        //用户功能设置(支持行业功能续费)
        *setUserPttFunctionsV2({ payload }, { put, call }) {
            let datas = yield call(apiUserPttSetFunctionsV2, payload)
            return datas
        },
        //查询功能权限
        *getUserPttFunctions({ payload }, { put, call }) {
            let datas = yield call(apiuserPttGetFunctions, payload)
            return datas
        },
        //查询行业功能组
        *getTradeFuncGroupList({ payload }, { put, call }) {
            let datas = yield call(apiuserPttGetFuncGroupList, payload)
            return datas
        },
        //查询账号信息
        *getUserPttInfo({ payload }, { put, call }) {
            let datas = yield call(apiuserPttGetUserInfo, payload)
            return datas
        },
    },
    reducers: {
        updateState(state, { payload }) {
            return {
                ...state,
                ...payload,
            };
        },
    },
};
